// Import CryptoJS using ES Module syntax
import CryptoJS from 'crypto-js';

// Function to hash a file using FileReader and CryptoJS
export const hashFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      // Convert ArrayBuffer to WordArray for CryptoJS
      const fileContent = event.target.result;
      const wordArray = CryptoJS.lib.WordArray.create(new Uint8Array(fileContent));
      const fileHash = CryptoJS.SHA256(wordArray).toString();
      resolve(fileHash);
    };
    reader.onerror = (error) => reject(error);
    reader.readAsArrayBuffer(file); // Read file as ArrayBuffer
  });
};

// Function to create an event hash
export const hashEvent = async (tokenId, eventName, eventDescription, eventAddress, fileHash) => {
  try {
    const combinedData = `${tokenId}-${eventName}-${eventDescription}-${eventAddress}-${fileHash}`;
    const eventHash = CryptoJS.SHA256(combinedData).toString(CryptoJS.enc.Hex);
    return eventHash;
  } catch (error) {
    console.error('Error creating event hash:', error);
    throw new Error('Failed to compute event hash');
  }
};

